import type { ActionPoint, Enps } from '@/types'

export enum SurveyGroup {
  OVERALL = 'Meta',
  EMPLOYEE = 'Mitarbeiter',
  PARTNER = 'Lieferanten',
  CUSTOMER = 'Kunden',
}

export interface Survey {
  actionPoints?: ActionPoint[]
  care: number
  companyId: number
  competence: number
  enps: Enps
  id: number
  iterationId: string
  name: string
  reliability: number
  shareLink: string
  sincerity: number
  surveyGroupName: string
  surveyGroupType: SurveyGroup
  surveySparrowSurveyId: number
  trusty: number
  wordCloud: Word[]
  lastImport: string
}

export type SurveyResponse = {
  id: number
  sincerity: number
  reliability: number
  competence: number
  care: number
  trusty: number
}

export type Word = {
  count: number
  keyword: string
}

export type LeaderShipScore = {
  care: number
  competence: number
  reliability: number
  sincerity: number
  trusty: number
}

export type SurveyResult = {
  id: number
  iterationId: string
  surveyGroupType: SurveyGroup
  surveyId: number
  subgroupName: string
  name: string
  nameEn?: string
  description: string
  membersCount?: number
  averageResponseTime?: number
  trusty: number
  sincerity: number
  reliability: number
  competence: number
  care: number
  wordCloud: Word[]
  lastScoreCalculation: string
  lastReco: string
  enps: Enps
  leadership: LeaderShipScore
}

/**
 * Survey Raw Data
 */

export type RawAnswer = {
  answer: string
  question: string
  question_id: string
  skipped: true
}

export type RawSurvey = {
  surveySparrowResponseId: number
  surveySparrowSurveyId: number
  completedTime: string
  startTime: string
  state: string
  answers: RawAnswer[]
  excluded: boolean
}
